export const SERVICE_AGREEMENT_TITLE = "ShadowScan Security Services Agreement";
export const SERVICE_AGREEMENT_VERSION = "2026-04-09";
export const SERVICE_AGREEMENT_LAST_UPDATED_LABEL = "9 April 2026";
export const SERVICE_AGREEMENT_ACCEPTED_EVENT_TYPE = "service_agreement_accepted";
export const REVIEWED_PRICING_SCHEDULE_TITLE = "ShadowScan Reviewed Pricing Schedule";
export const REVIEWED_PRICING_SCHEDULE_VERSION = "2026-03-24-dev-v1";
export const SERVICE_AGREEMENT_DOWNLOAD_FILE_NAME =
  `shadowscan-service-agreement-${SERVICE_AGREEMENT_VERSION}.pdf`;
export const SERVICE_AGREEMENT_DOWNLOAD_PATH =
  `/legal/${SERVICE_AGREEMENT_DOWNLOAD_FILE_NAME}`;

export const getServiceAgreementPortalUrl = (origin: string) =>
  `${origin.replace(/\/$/, "")}/portal/account`;
